// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-home-home-services----home-services-module---wrapper---3YGiL","container":"src-components-home-home-services----home-services-module---container---2NG0y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-services/home-services.module.css
// module id = 498
// module chunks = 35783957827783